import { APPROVALS_FEATURE_KEY } from "../../common";

export const sla_feature_key = 'ftr-sla-v2';

//Multi Product 
export const HCX = "HCX";
export const HFO = "HFO";
export const HCX_EMAIL_PLACEHOLDER = "support@acme.com";
export const HCX_TEXT_PLACEHOLDER = "support";
export const HFO_EMAIL_PLACEHOLDER = "payables@acme.com";
export const HFO_TEXT_PLACEHOLDER = "payables";
export const AVAILABLE = "available";
export const UNAVAILABLE = "unavailable";
export const FEATURE_ROUTE_MAPPING = {
    '/autoassignment': {
        'auto-assignment': 'unavailable'
    },
    '/connectors': {
        'rls-integrations': 'available'
    },
    '/marketplace': {
        'rls-integrations': 'unavailable'
    },
    '/csat': {
        'csat': 'unavailable'
    },
    '/permalink': {
        'rls-enhanced-permalinks': 'unavailable'
    },
    '/sla_v2': {
        'ftr-sla-v2': 'unavailable'
    },
    '/sla': {
        'ftr-sla-v2': 'available'
    },
    '/approvals': {
        [APPROVALS_FEATURE_KEY]: 'available'
    }
}

// create SM
export const EMAIL_TOOLTIP_TEXT = "Use an existing Workspace Gmail account or Workspace Group address (that you are a member of).";
export const SM_TOOLTIP_TEXT = "Give an appropriate name for your shared inbox.";
export const USERS_TOOLTIP_TEXT = "Add members to collaborate on the emails added to this shared inbox.";
export const ADD_USER_GROUP_LABEL = 'Add Users and Groups';
export const ADD_MEMBERS_LABEL = 'Add members to the shared inbox';
export const INBOX_CREATION_TOTAL_STEPS = 2;
export const SM_USAGE_INPUT_TITLE = "What will you use this shared inbox for?";
export const SM_USAGE_INPUT_LIST = [
    "Customer service",
    "Finance",
    "Sales",
    "HR",
    "IT",
    "Others",
  ];
export const SM_USAGE_INPUT_TOOLTIP = "This information will help us tailor the experience for you."

// channels
export const CHANNEL_TYPE_EMAIL = 'email';
export const CHANNEL_TYPE_CHAT = 'chat';
export const CHANNEL_TYPE_WHATSAPP = 'whatsapp';
export const CHANNEL_TYPE_AIRCALL = 'aircall';
export const SUPPORT = "support";
export const SALES = "sales";
export const PAYABLES = "payables";
export const RECIEVEABLES = "receivables";

// Automations
export const ASSIGN_AMONG_MIN_USERS = 2;
export const NO_TAGS_TOOLTIP_MSG = "Set up tags in your mailbox to use this action";
export const DEFAULT_TOOLTIP_MSG = 'This action can only be selected once';
export const ASSIGN_AMONG = "assign_among";

export const ONBOARD_CONTENT = "Loved by customers across 30+ countries";
export const ONBOARD_CAPTION = "We are committed to protecting your data and privacy";
export const ONBOARD_DESC_HCX = "Hiver’s a very friendly customer service platform. As it sits inside Gmail, it doesn’t give you an alien feel. Assigning emails is straightforward - it takes away with the complexities of a ticketing system.";
export const ONBOARD_FOOTER_HCX_1 = "Christian Sibayan |";
export const ONBOARD_FOOTER_HCX_2 = "Oxford Business Group";
export const ONBOARD_DESC_HFO = "I have visibility into all emails coming to the accounting@inbox - from inside Gmail. I'm able to assign these queries faster and also collaborate efficiently with my team, without having to send more emails and clutter inboxes. Hiver has made work super convenient.";
export const ONBOARD_FOOTER_HFO_1 = "Michelle Reznick |";
export const ONBOARD_FOOTER_HFO_2 = "Billing and Collections Team Leader, AppsFlyer";
export const SHOW_SETUP_GOALS_GUIDER = 'show_setup_goals_guider'
export const ONBOARDING_CHECKLIST_SM_CREATED = 'onboarding_checklist_sm_created'
export const SM_SETUP_GS_EVENT = '(SM setup) SM details entered'
export const SM_CREATED_GS_EVENT = '(SM setup) SM created'
export const MAIL_SYNC_COPY_TEXT = 'Import email history of upto 100 most-recent emails'
const TRAIL_MAIL_SYNC_LIMIT = 10
export const TRAIL_MAIL_SYNC_COPY_TEXT = `Import email history of upto ${TRAIL_MAIL_SYNC_LIMIT} most-recent emails`
export const TOGGLED_OFF_100_MS_GS_EVENT = '(SM setup) Toggled Off 100 emails sync'
export const TOGGLED_ON_100_MS_GS_EVENT = '(SM setup) Toggled On 100 emails sync'
export const HAS_EXTENDED_TRIAL_BEFORE = 'has-extended-trial-before';
export const HIVER_TAGS = ["SLA-Violated", "Harvey-Thank-You", "AI-Copilot-Source"]